import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { listFleetAsync } from "../../../../redux/features/fleetMaster";
import { useDispatch, useSelector } from "react-redux";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { BsFillEyeFill, BsPencilSquare, BsTelephoneFill } from "react-icons/bs";
import toast from "react-hot-toast";
import { changeStatus } from "../../../../Api/dispatch/fleet-dispatch";
import { Stack } from "@mui/material";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import { fleetExpiationReportAsync } from "../../../../redux/features/reportSlice";
import * as XLSX from "xlsx";
import { useBoolean } from "../../../../Hooks/useBoolean";
import CustomModal from "../../../../components/common/Modal";
import { listFleetExpratioRecordAsync } from "../../../../redux/features/fleetMasterExpirationSlice";

export default function FleetMasterList() {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const fleetMaster = useSelector((state) => state.fleetMaster);
   const fleetMasterList = fleetMaster?.dataList;
   const [records, setRecords] = useState([]);
   const [expiration_records, setExpirationRecords] = useState([]);

   const fleetMasterExpirationList = useSelector(
      (state) => state.fleetMasterExpiration?.dataList,
   );

   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });

   const expirationReportPopup = useBoolean();

   useEffect(() => {
      if (fleetMasterList) {
         setRecords(fleetMasterList);
      }
   }, [fleetMasterList]);

   useEffect(() => {
      if (fleetMasterExpirationList) {
         setExpirationRecords(fleetMasterExpirationList);
      }
   }, [fleetMasterExpirationList]);

   // Handle active inactive
   const handleActiveInactive = (fleet) => {
      setIsActiveLoading({ id: fleet?.id, status: true });
      changeStatus({ id: fleet?.id, status: fleet?.is_active === "1" ? "0" : "1" })
         .then((res) => {
            setIsActiveLoading({ id: fleet?.id, status: false });
            dispatch(listFleetAsync({}));
            toast.success(
               `fleet ${fleet?.is_active === "1" ? "deactivated" : "activated"}`,
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: fleet?.id, status: false });
            //toast.error(
            //    `Failed to ${fleet?.is_active === "1" ? "deactivate" : "activate"} fleet`
            // );
         });
   };

   const [isModalVisible, setIsModalVisible] = useState(true);
   // const handleShowModal = () => {
   //    setIsModalVisible(true);
   // };
   const handleCloseModal = () => {
      setIsModalVisible(false);
   };
   const handleExpirationReport = (data) => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         fleetExpiationReportAsync({
            data: data,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "TT No.", // Vehicle number
                  "PERMIT Exp.", // national permit
                  "TAX Exp.", // mv exp
                  "FITNESS Exp.", // fitness
                  "PUC Exp.", // PUC
                  "EXPLOSIVE Exp.", // peso
                  "Insurance Exp.",
                  "Consultant Name",
                  "Consultant Phone",
               ];

               const emiArr = [];

               report?.forEach?.((item, index) => {
                  const arr = [];

                  // const expiringDocs = item?.expiring_documents
                  //    ? Object.entries(item.expiring_documents)
                  //          .map(([key, value]) => `${key}: ${value}`)
                  //          .join(", ")
                  //    : "-";

                  arr.push(
                     index + 1, // S. No.
                     item?.vehicle?.vehicle_no ?? "-", // Vehicle No.
                     item?.expiring_documents?.National_Permit ?? "-",
                     item?.expiring_documents?.MV_Tax ?? "-",
                     item?.expiring_documents?.Fitness ?? "-",
                     item?.expiring_documents?.PUC ?? "-",
                     item?.expiring_documents?.PESO ?? "-",
                     item?.expiring_documents?.Insurance ?? "-",
                     item?.vehicle?.consultant_person ?? "-",
                     item?.vehicle?.consultant_phone ?? "-",
                  );
                  emiArr.push(arr);
               });

               const sheetData = [headers, ...emiArr];

               const ws = XLSX.utils.aoa_to_sheet(sheetData);
               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "FLEET_EXPIRATION_REPORT.xlsx");
               dispatch(backdropLoadingAction(false));
               expirationReportPopup.onFalse();
            },
         }),
      );
   };

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listFleetAsync({
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
         }),
      );
   }, []);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listFleetExpratioRecordAsync({
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
         }),
      );
   }, []);

   const columns = [
      {
         name: "Vehicle No",
         selector: (row) => row.vehicle_no,
         sortable: true,
      },
      {
         name: "Chasis No",
         selector: (row) => row.chasis_no,
      },
      {
         name: "Engine No",
         selector: (row) => row.engine_no,
      },
      {
         name: "Vehicle Owner Name",
         selector: (row) => row.vehicle_owner_name,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => (
            <div className="d-flex align-items-center">
               <button
                  className="btn"
                  onClick={() => navigate(`/fleet-master/view/${row?.id}`)}
               >
                  <BsPencilSquare
                     className="text-primary"
                     style={{ height: "1.5rem", width: "1.5rem" }}
                  />
               </button>
               {/* <CustomToggleSwitch
                  checked={row?.is_active === "1"}
                  onChange={() => handleActiveInactive(row)}
                  isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
               /> */}
            </div>
         ),
      },
   ];

   const expiration_colums = [
      {
         name: "Vehicle No",
         selector: (row) => row.vehicle?.vehicle_no,
         sortable: true,
         width: "140px",
      },
      {
         name: "Expiring Documents",
         cell: (row) => {
            const docs = row.expiring_documents || {};
            return (
               <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  {Object.entries(docs).map(([doc, date], index) => (
                     <div
                        key={index}
                        style={{
                           display: "flex",
                           justifyContent: "space-between",
                           width: "170px", // adjust width as needed
                           fontSize: "13px",
                        }}
                     >
                        <span>{doc}:</span>
                        <span>{date}</span>
                     </div>
                  ))}
               </div>
            );
         },
         sortable: false,
      },
      {
         name: "Consultant Contact",
         cell: (row) => {
            const person = row.vehicle?.consultant_person;
            const phone = row.vehicle?.consultant_phone;
            return (
               <div style={{ display: "flex", flexDirection: "column", fontSize: "13px", gap: "4px" }}>
                  {person ? (
                     <>
                        <span style={{ fontWeight: "bold" }}>{person}</span>
                        {phone && (
                           <a
                              href={`tel:${phone}`}
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 gap: "6px",
                                 color: "#17a2b8",
                                 textDecoration: "none",
                                 fontWeight: "500",
                              }}
                           >
                              <BsTelephoneFill size={11} /> {phone}
                           </a>
                        )}
                     </>
                  ) : (
                     <span className="text-muted">No contact assigned</span>
                  )}
               </div>
            );
         },
         width: "220px",
      },
      {
         name: "Action",
         selector: (row) => (
            <button
               className="btn"
               onClick={() => navigate(`/fleet-master/view/${row?.vehicle?.id}`)}
            >
               <BsFillEyeFill
                  className="text-primary"
                  style={{ height: "1.5rem", width: "1.5rem" }}
               />
            </button>
         ),
         width: "100px",
         center: true,
      },
   ];

   const handleFilter = (e) => {
      const searchText = e.target.value?.toLowerCase();
      const newData = fleetMasterList?.filter((row) => {
         return (
            row.vehicle_no?.toLowerCase()?.includes(searchText) ||
            row.chasis_no?.toLowerCase()?.includes(searchText) ||
            row.vehicle_owner_name?.toLowerCase()?.includes(searchText) ||
            row.engine_no?.toLowerCase()?.includes(searchText)
         );
      });
      setRecords(newData);
   };
   return (
      <div>
         <BodyHeader title="Fleet Master List" />
         <div className="px-3">
            <div className="d-flex justify-content-between">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />
            </div>
            <CustomTable columns={columns} data={records} />

            <CustomModal
               title="Expiration Remarks"
               showModal={isModalVisible}
               handleCloseModal={handleCloseModal}
               modalSize="modal-lg"
               hideFooter={true}
               child={
                  <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                     <style>{`
                        #modal-default .modal-dialog {
                           max-width: 850px !important;
                           width: 90% !important;
                        }
                     `}</style>
                     <DownloadReportButton
                        title="Download Expiration Report"
                        onDownloadReport={handleExpirationReport}
                        confirmPopup={expirationReportPopup}
                     />

                     <CustomTable columns={expiration_colums} data={expiration_records} />
                  </div>
               }
            />
         </div>
      </div>
   );
}
